<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex>
        <v-layout align-center justify-center column pb-2>
          <router-link to="/register">
            <button to="/register" class="button">Register for free</button>
          </router-link>
        </v-layout>

        <v-layout align-start justify-center column>
          <ul class="features">
            <li class="features__item features__item--site">Official website</li>
            <li class="features__item features__item--app">Official App</li>
            <li class="features__item features__item--live">Forest Live</li>
          </ul>
          <h1 class="heading-3">Coming soon</h1>
          <ul class="features">
            <li class="features__item features__item--store">Official store</li>
            <li class="features__item features__item--ticketing">Ticketing</li>
          </ul>

          
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "HomeRegister"
};
</script>

<style lang="scss" scoped>
 .heading-3 {
        text-align: center;
        align-content: center;
        align-self: center;
        margin: 10px auto 0;
      }
.features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 10px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;

    &__item {
      flex-grow: 1;
      flex-basis: 0;
      margin: 0 10px 30px;
      font-size: 15px;
      font-style: normal;
      font-weight: normal;
      line-height: 1.47;
      text-align: center;
      white-space: nowrap;

      span {
        display: block;
      }

      &:before {
        content: '';
        display: block;
        margin: 0 auto 10px;
        height: 97px;
        width: 97px;
        background-color: rgba(255, 255, 255, 0.75);
        background-position: 50%;
        background-repeat: no-repeat;
        border: 2px solid #fff;
        border-radius: 50%;
      }

      &--site:before {
        background-image: url('../assets/features/forest-plus.svg');
        background-size: 64px;
        background-position: 50% 45%;
      }

      // &--store:before {
      //   background-image: url('../assets/features/retail.svg');
      //   background-size: 64px;
      //   background-position: 50% 45%;
      // }

      &--points:before {
        background-image: url('../assets/features/reward-points.svg');
        background-size: 48px;
        background-position: 50% 50%;
      }

      &--store:before {
        background-image: url('../assets/features/retail.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--plus:before {
        background-image: url('../assets/features/forest-plus.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--live:before {
        background-image: url('../assets/features/forest-live.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--app:before {
        background-image: url('../assets/features/app.svg');
        background-size: 62px;
      }

      &--ticketing {
        opacity: 1;

        &:before {
          background-image: url('../assets/features/tickets.svg');
          background-size: 62px;
        }
      }
    }
  }
</style>
